/**
 * @file 模型库和数据集页入口
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Banner from '../../components/banner/Banner';
import MoreList from './components/more-list/MoreList';
import ToolList from './components/tool-list/ToolList';

const ModelAndDataSet: React.FC = () => {
    return (
        <div className="page paddle-mad-page">
            <Header />
            <Banner
                title="模型库和数据集"
                subtitle="寻找对您业务有帮助的模型和数据集"
                divider
            />
            <div className="paddle-mad-page-container">
                <ToolList />

                <div className="paddle-context-h2">
                    更多
                </div>
                <MoreList />
            </div>
            <Footer />
        </div>
    );
};

export default ModelAndDataSet;
